import React from "react";
import { FillPct } from "./types";

type Props = {
  depotIds: string[];
  selectedDepot: string;
  onChangeDepot: (v: string) => void;

  cellSize: number;
  setCellSize: (n: number) => void;

  highlight: FillPct | null;
  setHighlight: (v: FillPct | null) => void;

  onExportPNG: () => void;
  onExportPDF: () => void;
  exporting: null | "png" | "pdf";

  showDepotPicker?: boolean;
};

const Toolbar: React.FC<Props> = ({
  depotIds,
  selectedDepot,
  onChangeDepot,
  cellSize,
  setCellSize,
  highlight,
  setHighlight,
  onExportPNG,
  onExportPDF,
  exporting,
  showDepotPicker = true,
}) => {
  return (
    <div className="wm-toolbar">
      {showDepotPicker && (
        <div className="wm-field">
          <span className="wm-field-label">Depozit</span>
          <select
            className="wm-select"
            value={selectedDepot}
            onChange={(e) => onChangeDepot(e.target.value)}>
            <option value="ALL">All</option>
            {depotIds.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="wm-density">
        <span>Cell</span>
        <input
          type="range"
          min={8}
          max={28}
          step={1}
          value={cellSize}
          onChange={(e) => setCellSize(Number(e.target.value))}
        />
        <span className="wm-density-val">{cellSize}px</span>
      </div>

      <div className="wm-density">
        <span>Highlight</span>
        <select
          value={highlight ?? ""}
          onChange={(e) => {
            const v =
              e.target.value === ""
                ? null
                : (Number(e.target.value) as FillPct);
            setHighlight(v);
          }}>
          <option value="">off</option>
          <option value="0">≥ 0%</option>
          <option value="25">≥ 25%</option>
          <option value="50">≥ 50%</option>
          <option value="75">≥ 75%</option>
          <option value="100">= 100%</option>
        </select>
      </div>

      <div className="wm-actions" style={{ marginLeft: "auto" }}>
        <button className="wm-btn" onClick={onExportPNG} disabled={!!exporting}>
          Export PNG
        </button>
        <button className="wm-btn" onClick={onExportPDF} disabled={!!exporting}>
          Export PDF
        </button>
      </div>
    </div>
  );
};

export default Toolbar;
